(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cvvReturnConfirmationReady) return;
    window.__cvvReturnConfirmationReady = true;

    const blockUnchecked = (checkbox) => {
      if (!checkbox || checkbox.checked) return false;

      checkbox.setCustomValidity(checkbox.dataset.cvvError || '');
      checkbox.reportValidity();
      return true;
    };

    document.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const button = event.target.closest('[ref="addToCartButton"]');
        if (!button) return;

        const productArea =
          button.closest('.product-details') ||
          button.closest('[data-product-id]') ||
          document;

        const checkbox = productArea.querySelector('[data-cvv-return-checkbox]');
        if (!blockUnchecked(checkbox)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    document.addEventListener(
      'change',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const checkbox = event.target.closest('[data-cvv-return-checkbox]');
        if (!checkbox || !checkbox.checked) return;

        checkbox.setCustomValidity('');
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
